function formatMonthYear(date: Date, locale: string): string {
    return new Intl.DateTimeFormat(locale, { month: 'long', year: 'numeric' }).format(date);
}

/**
 * Inclusive month labels for churn-warning copy.
 *
 * Each period is the first and last *whole* month it covers, so no month is
 * shared between the current and comparison windows (e.g. a 6-month window is
 * "Januar 2026 bis Juni 2026", compared with "Juli 2025 bis Dezember 2025").
 * Returns the current window, the immediately preceding window (`prev_*`), and
 * the same window one year earlier (`year_ago_*`), so a translation string can
 * pick whichever comparison it means.
 *
 * ponytail: the backend exposes no real comparison window, so we anchor to the
 * last completed calendar month at view time. If an insight's true data window
 * ever differs from "trailing months ending last completed month", pass the
 * window from the backend instead of computing it here.
 */
export function churnWarningPeriodArgs(
    lengthMonths: number,
    locale: string,
): Record<string, string | number> {
    const now = new Date();
    // First of the month `monthsAgo` before now; JS Date normalises negative months across years.
    const monthStart = (monthsAgo: number): Date =>
        new Date(now.getFullYear(), now.getMonth() - monthsAgo, 1);

    return {
        cur_start: formatMonthYear(monthStart(lengthMonths), locale),
        cur_end: formatMonthYear(monthStart(1), locale), // last completed month
        prev_start: formatMonthYear(monthStart(lengthMonths * 2), locale),
        prev_end: formatMonthYear(monthStart(lengthMonths + 1), locale),
        year_ago_start: formatMonthYear(monthStart(12 + lengthMonths), locale),
        year_ago_end: formatMonthYear(monthStart(13), locale),
    };
}
